import {
    IonIcon,
    useIonActionSheet,
    IonNote,
    IonText,
    IonBadge,
    IonButton
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    pencil,
    close,
    chevronDownCircleOutline,
    chevronUpCircleOutline
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { colorTheme } from '../../utils/constants';

// All actions
const A_EDIT = 'Edit';
const A_CANCEL = 'Cancel';
const A_DELETE = 'Delete';

const UnitsListItem = ({unit, unitId, showDetails, handleUnitAction, occupied, rentAmount, taxRate, propertyName, unitName, currency, userAllPerms}) => {
    const [showExtraDetails, setShowExtraDetails] = useState(false);
    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])

    const [present] = useIonActionSheet();
    const [extraData, setExtraData] = useState([
        { label: "Property", value: propertyName },
        { label: "Unit", value: unitName },
        { label: "Rent Amount", value: rentAmount },
        { label: "Tax", value: `${taxRate}%` },
        { label: "Occupied", value: occupied? "Yes" : "No" }
    ]);

    const actionsRequiringAllUnitPerms = [A_EDIT, A_DELETE];

    const open = async () => {
        const mode = getMode();
        const buttons = [{
          text:  A_EDIT,
          role: 'destructive',
          icon: mode !== 'ios' ? pencil : '',
          handler: () => {
              handleUnitAction('edit', unitId);
          }
        },
        {
          text: A_DELETE,
          icon: mode !== 'ios' ? trash : '',
          handler: () => {
            handleUnitAction('delete', unitId);
          }
        }, {
          text: A_CANCEL,
          role: 'cancel',
          icon: mode !== 'ios' ? close : '',
          handler: () => {}
        }];

        let filteredButtons = buttons;
        if(!userAllPerms.unit){
          filteredButtons = filteredButtons.filter(button => !actionsRequiringAllUnitPerms.includes(button.text));
        }

        present({
          header: propertyName + "  " + unitName,
          buttons: filteredButtons
        });
    }

    return (
        <div className='mx-1 mx-md-4' key={unitId}>
              <Row style={{width: '100%'}} className='my-2 mx-0 py-1 shadow-sm rounded'>
          <Row className='mx-0 px-0 rounded'
          >
            <Col id='units-page-expand-details' onClick={ () => { setShowExtraDetails(!showExtraDetails)} } xs={6} md={6}>
              <Row>
              <Col xs={12} md={5}>
                <div className="d-flex align-items-center">
                  <strong>{unitName}</strong>
                  <IonIcon
                    style={{fontSize: '20px', color: 'var(--ion-color-primary)', marginRight: '10px' }}
                    icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                  ></IonIcon>
                </div>
              </Col>
              <Col xs={12} md={5}>
                <IonNote>{propertyName}</IonNote>
              </Col>
              </Row>
            </Col>

            <Col xs={5} md={5}>
              <Row>
              <Col xs={12} md={6}>
                <IonText><strong>{currency} {rentAmount}</strong> <span style={{fontSize: '12px'}}></span></IonText>
              </Col>
              <Col xs={12} md={6}>
                <IonBadge
                  color={occupied? "light" : "warning"}
                  style={{fontSize: '12px'}}
                >
                  {occupied? "Occupied" : "Not occupied"}
                </IonBadge>

              </Col>
              </Row>
            </Col>

            <div style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon onClick={open} size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon id='units-page-menu-items' onClick={open} size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div>
          </Row>

            {showExtraDetails && (<Row style={{backgroundColor: colorTheme["primary"]["25"], overflow: "hidden" }} className='mx-0 mb-2 px-0 py-3 rounded tenant-list-row'>
                <Row>
                    <IonButton 
                        fill="outline"
                        onClick={(e) => {
                            e.stopPropagation();
                            open();
                        }}
                    >
                        Options
                    </IonButton>
                </Row>
                { extraData.map((data, index) => (
                    <Row key={index} className='border-bottom ml-0.5 my-1'>
                      <Col  xs={5} md={3}><strong>{data.label}</strong></Col>
                      <Col xs={7} md={8}>
                        <span style={{fontSize: '16px'}}>{data.value}</span>
                      </Col>
                    </Row>
                  ))}
            </Row>)}
            </Row>
        </div>
    )
}
export default UnitsListItem;